import React, { useEffect } from 'react';
import "./home360-reunioes.component.scss";
import * as PANOLENS from "panolens";
import * as THREE from "three";

import imgPisoInferiorReunioes from '../../../assets/panolens/piso-inferior-reunioes.jpg';
import imgInfoSpot from '../../../assets/panolens/info-spot.png';
import imgInfoSpotPiso from '../../../assets/panolens/pt-chao.png';
import { SnackService } from '../../../services/snack.service';
import { sendEvent } from '../../../scripts/events';
import { LoadVideoBgService } from '../../../services/load-video-bg.service';
import { ROTAVIDEOS } from '../../../constants/rotas-videos.constant';
import { Button } from '@material-ui/core';

import icoPanoOff from '../../../assets/panolens/ico-pano-off.svg';
import icoPanoOn from '../../../assets/panolens/ico-pano-on.svg';
import { Ativa360Service } from '../../../services/ativa360.service';

const panoramaInferiorReunioes = new PANOLENS.ImagePanorama(imgPisoInferiorReunioes);

const viewerInferiorReunioes = new PANOLENS.Viewer({
    container: document.querySelector("#home-inferior-reunioes"),
    controlBar: true,
    autoHideInfospot: false
});

viewerInferiorReunioes.add(panoramaInferiorReunioes);
viewerInferiorReunioes.getCamera().fov = 120;
viewerInferiorReunioes.getCamera().updateProjectionMatrix();
//viewerInferiorReunioes.OrbitControls.noZoom = true;
// posição inicial camera
viewerInferiorReunioes.camera.position.set(-0.37762263011158637, 0.1075657714400121, 0.91969057516217);
setTimeout(() => {
    (document.querySelectorAll(".panolens-container")[2]).classList.add('reunioes');
}, 500);

let x = 50;
let y = -130;
let z = -150;

const createInfoSpot = (pos: any, img: any, hoverTxt: string, send_event: any, nome_video: any) => {
    let position = new THREE.Vector3(pos.x, pos.y, pos.z);
    let infospot = new PANOLENS.Infospot(30, img, false);
    infospot.position.copy(position);
    infospot.addHoverText(hoverTxt);
    infospot.addEventListener('click', () => {
        sendEvent(send_event);
        localStorage.setItem('urlFrom', 'homeReunioes')
        LoadVideoBgService.sendNomeVideo(nome_video);
    });
    panoramaInferiorReunioes.add(infospot);
}

// Reuniões
createInfoSpot(
    { x: 130, y: 30, z: -150 },
    imgInfoSpot,
    'Reuniões',
    { category: 'home', label: 'menu_pts_reunioes', action: 'click' },
    ROTAVIDEOS.reunioes
);

// Clima
createInfoSpot(
    { x: -70, y: -10, z: -150 },
    imgInfoSpot,
    'Clima',
    { category: 'home', label: 'menu_pts_clima', action: 'click' },
    ROTAVIDEOS.clima
);

// Fórum
createInfoSpot(
    { x: -190, y: 30, z: 10 },
    imgInfoSpot,
    'Fórum',
    { category: 'home', label: 'menu_pts_forum', action: 'click' },
    ROTAVIDEOS.forum
);

// Lives
createInfoSpot(
    { x: 130, y: -50, z: 210 },
    imgInfoSpot,
    'Lives',
    { category: 'home', label: 'menu_pts_lives', action: 'click' },
    ROTAVIDEOS.lives
);


// Visão Home
// createInfoSpot(
//     { x: 50, y: -170, z: 130 },
//     imgInfoSpotPiso,
//     'Visão Home',
//     { category: 'home', label: 'menu_pts_visao_home', action: 'click' },
//     ROTAVIDEOS.home
// );

let positionPadrao = new THREE.Vector3(210, -80, -210);
let infospotPadrao = new PANOLENS.Infospot(30, imgInfoSpotPiso, false);
infospotPadrao.position.copy(positionPadrao);
infospotPadrao.addHoverText('Infospot padrao');
infospotPadrao.addEventListener('click', () => { });
// panoramaInferiorReunioes.add(infospotPadrao);

var UA = navigator.userAgent;

export default function Home360ReunioesComponent() {

    const [isAndroid, setIsAndroid] = React.useState<boolean>(/\b(Android|iPhone|Windows Phone|iPad|iPod|BlackBerry|webOS)\b/i.test(UA));
    const [isIos, setIsIos] = React.useState<boolean>(/\b(iPhone|iPad|iPod)\b/i.test(UA));
    const [toggleOculus, setToggleOculus] = React.useState<boolean>(Ativa360Service.get360Ativo());

    useEffect(() => {
        document.body.classList.add("home-reunioes");
        document.body.classList.add("show-powered");

        if (toggleOculus) {
            viewerInferiorReunioes.enableControl(1);
            viewerInferiorReunioes.enableEffect( PANOLENS.MODES.CARDBOARD);
        } else {
            viewerInferiorReunioes.enableControl(0);
            viewerInferiorReunioes.enableEffect( PANOLENS.MODES.NORMAL);
        }

        return () => {
            document.body.classList.remove("show-powered");
            document.body.classList.remove("home-reunioes");
        }
    }, []);

    document.addEventListener('keydown', function (e: any) {
        //console.log(e.keyCode);
        switch (e.keyCode) {
            case 65:
                //alert('left'); ---- A
                x -= 10;
                positionPadrao = new THREE.Vector3(
                    x,
                    y,
                    z
                );
                infospotPadrao.position.copy(positionPadrao);
                break;
            case 68:
                //alert('right'); ---- D
                x += 10;
                positionPadrao = new THREE.Vector3(
                    x,
                    y,
                    z
                );
                infospotPadrao.position.copy(positionPadrao);
                break;
            case 87:
                //alert('up'); ---- W
                y += 10;
                positionPadrao = new THREE.Vector3(
                    x,
                    y,
                    z
                );
                infospotPadrao.position.copy(positionPadrao);
                break;
            case 83:
                //alert('down'); ---- S
                y -= 10;
                positionPadrao = new THREE.Vector3(
                    x,
                    y,
                    z
                );
                infospotPadrao.position.copy(positionPadrao);
                break;
            case 90:
                //alert('profundidade'); ---- Z
                z += 10;
                positionPadrao = new THREE.Vector3(
                    x,
                    y,
                    z
                );
                infospotPadrao.position.copy(positionPadrao);
                break;
            case 88:
                //alert('profundidade'); ---- X
                z -= 10;
                positionPadrao = new THREE.Vector3(
                    x,
                    y,
                    z
                );
                infospotPadrao.position.copy(positionPadrao);
                console.log(positionPadrao);
                break;
            case 84:
                //alert('profundidade'); ---- T
                // tecla T para debugar posição inicial que deseja
                console.log(viewerInferiorReunioes.camera.position);
                break;
        }
    });

    const toggleOculusFunc = () => {

        if (!toggleOculus) {
            if (isIos) {
                (DeviceMotionEvent as any).requestPermission();
            }
            viewerInferiorReunioes.enableControl(1);
            viewerInferiorReunioes.enableEffect( PANOLENS.MODES.CARDBOARD);
        } else {
            viewerInferiorReunioes.enableControl(0);
            viewerInferiorReunioes.enableEffect( PANOLENS.MODES.NORMAL);
        }

        setToggleOculus(!toggleOculus);
        Ativa360Service.toggle360Ativo();
    }

    return (
        <>
            <div id="home-inferior-reunioes">
                { }
                <img className='seta-frente' src={imgInfoSpotPiso} onClick={() => {
                    sendEvent({ category: 'home', label: 'menu_pts_visao_home', action: 'click' });
                    LoadVideoBgService.sendNomeVideo(ROTAVIDEOS.home);
                }} />
            </div>

            {
                // isAndroid &&
                // <Button onClick={toggleOculusFunc} className={'bt-oculus ativo-' + toggleOculus}>
                //     <img className='pano-off' src={icoPanoOff} />
                //     <img className='pano-on' src={icoPanoOn} />
                // </Button>
            }
        </>
    );
}